// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/pilot_deep_link_qr_code" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { freeTrialPilotDeepLinkQrCode } from "./constants";
import type { FreeTrialPilotDeepLinkQrCodeResult } from "./types";
import { isFreeTrialPilotDeepLinkQrCodeResult } from "./validators";

export const getFreeTrialPilotDeepLinkQrCode = reactQueryFetcherAdapter(
  freeTrialPilotDeepLinkQrCode,
  (signal: AbortSignal, linkPath: string): Promise<FreeTrialPilotDeepLinkQrCodeResult> => {
    return fetch("/pilot_deep_link_qr_code", "GET", { deeplink_target: linkPath }, { signal });
  },
  isFreeTrialPilotDeepLinkQrCodeResult
);
